import { Box, Typography } from '@mui/material';
import { TextFieldv2 } from 'views/Portal/components';

export const OptionRow = ({
    label,
    value,
    onChangeOption
}: {
    label: string;
    value: string | undefined;
    onChangeOption: (newValue: string) => void;
}) => (
    <Box sx={{ borderLeft: '1px solid #D9D9D9', p: '8px', pl: '30px' }}>
        <Typography mb="4px">{label}</Typography>
        <TextFieldv2 value={value} onChange={(e) => onChangeOption(e.target.value)} />
    </Box>
);
